<template>
  <div>
    <h3>ログイン</h3>
    <button @click="signInWithTwitter">Sign in with Twitter</button>
    <a href="https://us-central1-agarustore.cloudfunctions.net/generateLineLoginUri">Sign in with Line</a>
  </div>
</template>
<script>
import firebaselogin from './firebaselogin'
export default {
  name: 'sns-login',
  mixins: [firebaselogin],
  props: {
    customToken: String
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken,
    }
  },
  mounted() {
    if (this.customToken) {
      this.signInWithCustomToken()
    }
  },
  methods: {
    signInWithTwitter() {
      const provider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().signInWithPopup(provider)
      .catch(error => alert(error.message))
      .then(result => {
        const data = {
          nickname: result.user.displayName,
          email: result.user.providerData[0].email,
          uid: result.user.uid,
          sns: 'twitter',
          cpno: this.cpno
        }
        this.loginByFirebaseUid(data)
      })
    },
    signInWithCustomToken() {
      firebase.auth().signInWithCustomToken(this.customToken).then( result => {
        const data = {
          nickname: result.user.displayName,
          email: '',
          uid: result.user.uid,
          sns: 'line',
          cpno: this.cpno
        }
        this.loginByFirebaseUid(data)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SnsLogin.vue